import React, { Component } from 'react';
import {
  Box,
  Checkbox,
  TableCell,
  TableRow,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import i18n from '../../i18n';
import {
  getDoubleBookingLabel
} from '../../helpers/locationHelpers';
import { LocationType } from '../../validation';

class EcommDoubleBookingRows extends Component {

  changeHandler = (name, key) => (event) => {
    const {
      saveChange,
    } = this.props;
    event.persist();
    const { checked } = event.currentTarget;
    saveChange(name, checked, key);
  }

  getDoubleBookings = () => {
    const {
      locationType,
    } = this.props;
    const doubleBookings = locationType.requiredPositions.filter((pos) => pos.allowDoubleBooking && pos.enabled);

    // group gendered positions
    return doubleBookings
      .filter((pos) => pos.gender == null || pos.gender === 'male')
      .map((pos) => { 
        return { ...pos, gender: null } 
      });
  }


  render() {
    const {
      canEdit,
      studioData,
      getTabIndex,
    } = this.props;

    return (
      <>
        { this.getDoubleBookings().map((doubleBooking) => {
          return (
            <TableRow key={doubleBooking.doubleBookingField}>
              <TableCell key={doubleBooking.doubleBookingField} className="ecommTableLabel">
                <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
                  {i18n.t(getDoubleBookingLabel(doubleBooking.position)).toUpperCase()}
                </Box>
              </TableCell>
              {Object.keys(studioData).map((element, index) => {
                return (
                  <TableCell key={element} className="studioDataRight">
                    {(doubleBooking.gender == null || doubleBooking.gender === studioData[element].gender)?(
                      <Checkbox
                        inputProps={{
                          tabIndex: getTabIndex(index)
                        }}
                        className="studioDataCheckbox"
                        checked={studioData[element][doubleBooking.doubleBookingField]}
                        name={doubleBooking.doubleBookingField}
                        disabled={!canEdit}
                        onChange={this.changeHandler(doubleBooking.doubleBookingField, element)}
                      />
                    ):''}
                  </TableCell>
                );
              })}
            </TableRow>
          )

        })}
      </>
    )
  }
}

EcommDoubleBookingRows.propTypes = {
  locationType: LocationType.isRequired,
  saveChange: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  studioData: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  getTabIndex: PropTypes.func.isRequired,
}

export default EcommDoubleBookingRows
